module.exports = __webpack_public_path__ + "static/media/new5.1175661a.png";